(function (host, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (host.MNLAtelierThumbnailsV1502) host.MNLAtelierThumbnailsV1502.boot(host.document);
  else host.MNLAtelierThumbnailsV1502 = api.start(host, host.document);
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  var TAU = Math.PI * 2;
  var PACKARI = Object.freeze({ millimetersPerUnit: 64, originMm: 96, bodyDiameterMm: 103, bodyHeightMm: 183, openingDiameterMm: 80, lidDiameterMm: 99, lidHeightMm: 20, installedLidBottomMm: 165, labelWidthMm: 228, labelHeightMm: 143.2, labelBottomMm: 14, decalOffsetMm: 0.05 });
  function packariDimensions() { return Object.assign({}, PACKARI); }
  function labelPoint(u, v) {
    var radiusMm = PACKARI.bodyDiameterMm / 2 + PACKARI.decalOffsetMm;
    var span = PACKARI.labelWidthMm / radiusMm;
    return { theta: (u - 0.5) * span, radius: radiusMm / PACKARI.millimetersPerUnit,
      y: (PACKARI.labelBottomMm + PACKARI.labelHeightMm * (1 - v) - PACKARI.originMm) / PACKARI.millimetersPerUnit };
  }
  var MONOGRAM = 'M0 0L0 364L48 334L48 100L141 178L233 100L233 257L280 214L280 0L141 116ZM66 146L66 512L107 512L107 263L217 392L217 146L174 183L174 257L105 183ZM130 329L130 512L281 512L249 451L180 451L180 384Z';

  function normalizeAngle(value) {
    value = Number(value);
    if (!Number.isFinite(value)) return 0;
    if (value >= -180 && value <= 180) return value;
    return ((value + 180) % 360 + 360) % 360 - 180;
  }

  function multiply(a, b) {
    var out = new Float32Array(16);
    for (var col = 0; col < 4; col++) {
      for (var row = 0; row < 4; row++) {
        for (var k = 0; k < 4; k++) out[col * 4 + row] += a[k * 4 + row] * b[col * 4 + k];
      }
    }
    return out;
  }

  function perspective(aspect) {
    var f = 1 / Math.tan(37 * Math.PI / 360), near = 0.1, far = 30;
    return new Float32Array([f / aspect, 0, 0, 0, 0, f, 0, 0,
      0, 0, (far + near) / (near - far), -1, 0, 0, 2 * far * near / (near - far), 0]);
  }

  function rotation(angle) {
    var y = angle * Math.PI / 180, cy = Math.cos(y), sy = Math.sin(y);
    var cx = Math.cos(0.16), sx = Math.sin(0.16);
    var ry = new Float32Array([cy, 0, -sy, 0, 0, 1, 0, 0, sy, 0, cy, 0, 0, 0, 0, 1]);
    var rx = new Float32Array([1, 0, 0, 0, 0, cx, sx, 0, 0, -sx, cx, 0, 0, 0, 0, 1]);
    return multiply(rx, ry);
  }

  // Profile entries are [radius, height]. Surface normals include the actual lid ribs.
  function lathe(profile, segments, ribAmplitude, ribCount, angleStart, angleSpan) {
    segments = Math.max(8, Math.min(768, Math.floor(segments || 96)));
    ribAmplitude = ribAmplitude || 0;
    ribCount = ribCount || 0;
    angleStart = Number.isFinite(angleStart) ? angleStart : -Math.PI;
    angleSpan = Number.isFinite(angleSpan) ? angleSpan : TAU;
    var data = [], indices = [];
    for (var row = 0; row < profile.length; row++) {
      var before = profile[Math.max(0, row - 1)], after = profile[Math.min(profile.length - 1, row + 1)];
      var dr = after[0] - before[0], dy = after[1] - before[1];
      for (var col = 0; col <= segments; col++) {
        var theta = angleStart + angleSpan * col / segments, s = Math.sin(theta), c = Math.cos(theta);
        var amount = profile[row][0] > 0.1 ? ribAmplitude : 0;
        var r = profile[row][0] + amount * (0.5 + 0.5 * Math.cos(theta * ribCount));
        var derivative = -amount * 0.5 * ribCount * Math.sin(theta * ribCount);
        var tx = c * r + s * derivative, tz = -s * r + c * derivative;
        var nx = -tz * dy, ny = tz * s * dr - tx * c * dr, nz = tx * dy;
        var length = Math.hypot(nx, ny, nz);
        if (length < 0.00001) { nx = 0; ny = row === 0 ? -1 : 1; nz = 0; length = 1; }
        data.push(s * r, profile[row][1], c * r, nx / length, ny / length, nz / length,
          col / segments, row / (profile.length - 1));
      }
    }
    for (var y = 0; y < profile.length - 1; y++) {
      for (var x = 0; x < segments; x++) {
        var a = y * (segments + 1) + x, b = a + 1, d = a + segments + 1;
        indices.push(a, b, d, b, d + 1, d);
      }
    }
    return { vertices: new Float32Array(data), indices: new Uint16Array(indices) };
  }

  function geometry() {
    function profile(points) { return points.map(function (point) { return [point[0] / PACKARI.millimetersPerUnit, (point[1] - PACKARI.originMm) / PACKARI.millimetersPerUnit]; }); }
    var r = PACKARI.bodyDiameterMm / 2, mouth = PACKARI.openingDiameterMm / 2, cap = PACKARI.lidDiameterMm / 2;
    var labelRadius = r + PACKARI.decalOffsetMm, span = PACKARI.labelWidthMm / labelRadius;
    var labelBottom = PACKARI.labelBottomMm, labelTop = labelBottom + PACKARI.labelHeightMm;
    var lidBottom = PACKARI.installedLidBottomMm, lidTop = lidBottom + PACKARI.lidHeightMm;
    return {
      body: lathe(profile([[0, 0], [40, 0], [46, 0.5], [49, 1.5], [50.5, 3.5], [51.25, 6.5], [r, 10], [r, 162],
        [51.25, 162.8], [50.3, 163.6], [48.6, 164.5], [47.6, 165], [47.6, PACKARI.bodyHeightMm], [mouth, PACKARI.bodyHeightMm], [mouth, 174], [0, 174]]), 256),
      label: lathe(profile([[labelRadius, labelBottom], [labelRadius, labelTop]]), 256, 0, 0, -span / 2, span),
      lid: lathe(profile([[0, lidBottom], [47.5, lidBottom], [49.1, lidBottom + 0.4], [cap, lidBottom + 1.5], [cap, lidBottom + 3.2],
        [49.15, lidBottom + 3.8], [49.15, lidTop - 1.8], [48.7, lidTop - 0.7], [47.4, lidTop - 0.2], [45, lidTop], [0, lidTop]]), 288),
      grip: lathe(profile([[49.1, lidBottom + 4], [49.15, lidBottom + 4.5], [49.15, lidTop - 1.8], [49.0, lidTop - 1.3]]), 576, 0.35 / PACKARI.millimetersPerUnit, 72),
      rim: lathe(profile([[48.9, lidBottom], [49.2, lidBottom + 0.3], [49.2, lidBottom + 2.8], [48.9, lidBottom + 3.2]]), 192, 0.3 / PACKARI.millimetersPerUnit, 24),
      shadow: {
        vertices: new Float32Array([-1.5, -1.515, -1.15, 0, 1, 0, 0, 0,
          -1.5, -1.515, 1.15, 0, 1, 0, 0, 1, 1.5, -1.515, -1.15, 0, 1, 0, 1, 0,
          1.5, -1.515, 1.15, 0, 1, 0, 1, 1]),
        indices: new Uint16Array([0, 1, 2, 1, 3, 2])
      }
    };
  }

  var VERTEX = [
    'attribute vec3 aPosition; attribute vec3 aNormal; attribute vec2 aUv;',
    'uniform mat4 uModel; uniform mat4 uMvp;',
    'varying vec3 vNormal; varying vec3 vPosition; varying vec3 vLocal; varying vec2 vUv;',
    'void main(){ vec4 p=uModel*vec4(aPosition,1.0); vPosition=p.xyz;',
    'vNormal=mat3(uModel)*aNormal; vLocal=aPosition; vUv=aUv; gl_Position=uMvp*vec4(aPosition,1.0); }'
  ].join('\n');
  var FRAGMENT = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH',
    'precision highp float;',
    '#else',
    'precision mediump float;',
    '#endif',
    'uniform vec3 uColor; uniform float uMode; uniform float uSpecular; uniform vec3 uEye; uniform sampler2D uLabel;',
    'varying vec3 vNormal; varying vec3 vPosition; varying vec3 vLocal; varying vec2 vUv;',
    'void main(){',
    'if(uMode>1.5){vec2 p=(vUv-0.5)*2.0; vec2 q=p-vec2(0.14,-0.06); float a=exp(-2.8*dot(q,q))*0.24+exp(-8.0*dot(p,p))*0.34;',
    'gl_FragColor=vec4(0.17,0.13,0.10,a);return;}',
    'vec3 n=normalize(vNormal); vec3 light=normalize(vec3(-2.3,3.6,4.0));',
    'vec3 eye=normalize(uEye-vPosition);',
    'float diffuse=max(dot(n,light),0.0);',
    'vec3 base=uMode>0.5?texture2D(uLabel,vec2(vUv.x,1.0-vUv.y)).rgb:uColor;',
    'vec3 linearBase=pow(max(base,vec3(0.0)),vec3(2.2));',
    'float fill=max(dot(n,normalize(vec3(3.0,0.8,2.0))),0.0);',
    'float bounce=max(dot(n,normalize(vec3(0.2,-1.8,2.4))),0.0);',
    'float horizon=0.59+0.06*max(n.y,0.0);',
    'vec3 illumination=vec3(horizon)+vec3(1.0,0.986,0.964)*diffuse*0.38+vec3(0.945,0.968,1.0)*fill*0.14+vec3(1.0,0.945,0.885)*bounce*0.045;',
    'float shoulder=exp(-pow((vLocal.y-1.0546875)*25.0,2.0))*0.11;',
    'float baseShade=exp(-pow((vLocal.y+1.46)*20.0,2.0))*0.07;',
    'vec3 r=reflect(-eye,n);',
    'float softbox=exp(-pow((r.x+0.48)*3.5,2.0)-pow((r.y-0.40)*1.15,2.0))*smoothstep(0.05,0.9,r.z);',
    'float strip=exp(-pow((r.x-0.69)*10.0,2.0)-pow((r.y-0.16)*0.85,2.0))*smoothstep(0.05,0.9,r.z);',
    'float broad=pow(max(dot(n,normalize(light+eye)),0.0),uMode>0.5?24.0:64.0);',
    'float fresnel=0.04+0.96*pow(1.0-max(dot(n,eye),0.0),5.0);',
    'vec3 color=linearBase*illumination*(1.0-shoulder-baseShade)+vec3((softbox*0.36+strip*0.22+broad*0.18)*uSpecular*(0.75+fresnel));',
    'gl_FragColor=vec4(pow(max(color,vec3(0.0)),vec3(1.0/2.2)),1.0);}'
  ].join('\n');

  function fitText(ctx, text, x, y, maxWidth, size, weight, family) {
    text = String(text || '').slice(0, 140);
    do {
      ctx.font = (weight || '500') + ' ' + size + 'px ' + (family || 'Archivo, Arial, sans-serif');
      if (ctx.measureText(text).width <= maxWidth || size <= 12) break;
      size--;
    } while (true);
    ctx.fillText(text, x, y, maxWidth);
  }

  function formulaLines(value) {
    var text = String(value || '').trim().replace(/\s+/g, ' ').slice(0, 50).toLocaleUpperCase('fr-FR');
    var words = text.split(' ');
    if (words.length < 2) return ['', text];
    var split = 1, delta = Infinity;
    for (var i = 1; i < words.length; i++) {
      var next = Math.abs(words.slice(0, i).join(' ').length - words.slice(i).join(' ').length);
      if (next < delta) { delta = next; split = i; }
    }
    return [words.slice(0, split).join(' '), words.slice(split).join(' ')];
  }

  function paintBrand(ctx, color) {
    ctx.save();
    ctx.fillStyle = color || '#131514';
    if (typeof Path2D !== 'undefined') {
      var outline = 'M5.300 74.100L11.800 12.500L37.800 64.800L63.800 12.500L70.300 74.100L73.600 74.100L65.800 2L37.800 58.200L9.800 2L2 74.100L5.300 74.100Z M145.100 4.100L141.400 4.100L119.700 43.200L98.900 4.100L95.200 4.100L118.200 46.500L118.200 74.100L121.400 74.100L121.400 46.400L145.100 4.100Z M226.600 4.100L223.300 4.100L223.300 67.600L170 2L170 74.100L173.300 74.100L173.300 10.900L226.600 76.200L226.600 4.100Z M261.800 4.100L258.500 4.100L258.500 51.800Q258.500 57.000 259.850 61.300Q261.200 65.600 263.950 68.650Q266.700 71.700 270.650 73.400Q274.600 75.100 279.800 75.100L279.800 75.100Q285 75.100 289 73.400Q293 71.700 295.700 68.650Q298.400 65.600 299.800 61.300Q301.200 57.000 301.200 51.800L301.200 51.800L301.200 4.100L297.900 4.100L297.900 51.800Q297.900 61.100 293.150 66.550Q288.400 72.000 279.800 72.000L279.800 72.000Q271.300 72.000 266.550 66.550Q261.800 61.100 261.800 51.800L261.800 51.800L261.800 4.100Z M326.100 4.100L326.100 7.200L344.800 7.200L344.800 74.100L348.100 74.100L348.100 7.200L366.800 7.200L366.800 4.100L326.100 4.100Z M407.200 41.600L403.600 41.600L426.200 74.100L430.200 74.100L407.200 41.600ZM395.500 4.100L392.200 4.100L392.200 74.100L395.500 74.100L395.500 4.100ZM393.700 4.100L393.700 7.100L405.900 7.100Q411.900 7.100 416.500 8.950Q421.100 10.800 423.700 14.550Q426.300 18.300 426.300 23.900L426.300 23.900Q426.300 29.500 423.700 33.250Q421.100 37.000 416.500 38.900Q411.900 40.800 405.900 40.800L405.900 40.800L393.700 40.800L393.700 43.700L405.900 43.700Q412.700 43.700 418.000 41.450Q423.300 39.200 426.450 34.750Q429.600 30.300 429.600 23.900L429.600 23.900Q429.600 17.400 426.450 13.000Q423.300 8.600 418.000 6.350Q412.700 4.100 405.900 4.100L405.900 4.100L393.700 4.100Z M459.600 4.100L456.400 4.100L456.400 74.100L459.600 74.100L459.600 4.100Z M494.800 4.100L491.600 4.100L491.600 74.100L524.800 74.100L524.800 71.000L494.800 71.000L494.800 4.100Z M558.800 45.700L557.900 48.700L593 48.700L592.100 45.700L558.800 45.700ZM560.300 46.800L575.400 9.600L590.600 47.000L590.900 47.800L601.400 74.100L605.100 74.100L575.400 2L545.700 74.100L549.300 74.100L560 47.600L560.300 46.800Z M632.500 34.000L632.500 36.000L643.800 36.000Q649.400 36.000 653.750 34.350Q658.100 32.700 660.650 29.250Q663.200 25.800 663.200 20.500L663.200 20.500Q663.200 15.200 660.750 11.600Q658.300 8 653.850 6.050Q649.400 4.100 643.100 4.100L643.100 4.100L630 4.100L630 74.100L644.100 74.100Q650.900 74.100 656 71.950Q661.100 69.800 664 65.350Q666.900 60.900 666.900 54.000L666.900 54.000Q666.900 49.200 664.900 45.600Q662.900 42.000 659.600 39.650Q656.300 37.300 652.400 36.150Q648.500 35.000 644.800 35.000L644.800 35.000L632.500 35.000L632.500 36.900L644.100 36.900Q647.700 36.900 651.200 38.050Q654.700 39.200 657.500 41.350Q660.300 43.500 662 46.650Q663.700 49.800 663.700 53.800L663.700 53.800Q663.700 59.700 661.250 63.550Q658.800 67.400 654.400 69.250Q650 71.100 644.100 71.100L644.100 71.100L633.200 71.100L633.200 7.100L643.100 7.100Q651 7.100 655.450 10.650Q659.900 14.200 659.900 20.700L659.900 20.700Q659.900 25.400 657.600 28.350Q655.300 31.300 651.450 32.650Q647.600 34.000 643.100 34.000L643.100 34.000L632.500 34.000Z';
      ctx.translate(758, 163);
      ctx.scale(422 / 669, 422 / 669);
      ctx.fill(new Path2D(outline));
    } else {
      var letters = 'MYNUTRILAB'.split(''), size = 63, gap, width;
      do {
        ctx.font = '200 ' + size + 'px Jost, Arial, sans-serif';
        gap = size * 0.15;
        width = letters.reduce(function (sum, letter) { return sum + ctx.measureText(letter).width; }, 0) + gap * (letters.length - 1);
        if (width <= 422 || size <= 12) break;
        size--;
      } while (true);
      var x = 758;
      letters.forEach(function (letter) {
        ctx.fillText(letter, x, 188);
        x += ctx.measureText(letter).width + gap;
      });
    }
    ctx.restore();
  }

  function paintComposition(ctx, rows, title) {
    if (!Array.isArray(rows) || !rows.length) return;
    ctx.save(); ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
    ctx.fillStyle = '#101418'; fitText(ctx, title, 160, 180, 490, 30, '700', 'Arial, Helvetica, sans-serif');
    ctx.fillStyle = '#b9bcb4'; ctx.fillRect(160, 226, 490, 1.5);
    rows.slice(0, 11).forEach(function (row, index) {
      if (!row || typeof row.name !== 'string' || typeof row.dose !== 'string') return;
      var y = 266 + index * 52;
      ctx.textAlign = 'left'; ctx.fillStyle = '#101418';
      fitText(ctx, row.name, 160, y, 320, 22, '500', 'Arial, Helvetica, sans-serif');
      ctx.textAlign = 'right';
      fitText(ctx, row.dose, 650, y, 158, 23, '700', 'Arial, Helvetica, sans-serif');
      ctx.fillStyle = '#d8dad3'; ctx.fillRect(160, y + 25, 490, 1);
    });
    ctx.restore();
  }

  function paintLabel(canvas, label, flavorImage) {
    var ctx = canvas.getContext('2d');
    if (!ctx) throw new Error('Texture canvas unavailable');
    ctx.save();
    ctx.scale(canvas.width / 1818, canvas.height / 1142);
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, 1818, 1142);
    ctx.textAlign = 'left'; ctx.textBaseline = 'middle';
    ctx.fillStyle = '#080b0c';
    if (typeof Path2D !== 'undefined') {
      ctx.save(); ctx.translate(680, 26); ctx.scale(120 / 512, 120 / 512); ctx.fill(new Path2D(MONOGRAM)); ctx.restore();
      ctx.save(); ctx.translate(990, 24); ctx.scale(602 / 282, 602 / 282);
      var markGradient = ctx.createLinearGradient(0, 0, 282, 60);
      markGradient.addColorStop(0, '#f58013'); markGradient.addColorStop(0.52, '#ed4525'); markGradient.addColorStop(1, '#cf0756');
      ctx.fillStyle = markGradient; ctx.fill(new Path2D(MONOGRAM)); ctx.restore();
    }
    ctx.save(); ctx.translate(680 - 758 * (228 / 422), 164 - 163 * (228 / 422)); ctx.scale(228 / 422, 228 / 422); paintBrand(ctx, '#201d19'); ctx.restore();
    var family = 'Manrope, Arial, sans-serif';
    ctx.fillStyle = '#635b51'; fitText(ctx, 'PRÉ-WORKOUT PERSONNALISÉ', 680, 244, 280, 13, '700', family);
    var lines = formulaLines(label.name);
    ctx.fillStyle = '#201d19';
    if (lines[0]) fitText(ctx, lines[0], 680, 286, 280, 42, '800', family);
    var gradient = ctx.createLinearGradient(680, 0, 960, 60);
    gradient.addColorStop(0, '#f58013'); gradient.addColorStop(0.52, '#ed4525'); gradient.addColorStop(1, '#cf0756');
    ctx.fillStyle = gradient;
    fitText(ctx, lines[1], 680, lines[0] ? 330 : 286, 280, 42, '800', family);
    var identityY = lines[0] ? 383 : 339;
    ctx.fillStyle = '#635b51'; fitText(ctx, 'CONÇU POUR', 680, identityY, 280, 13, '700', family);
    ctx.fillStyle = '#201d19'; fitText(ctx, 'VOUS', 680, identityY + 25, 280, 22, '800', family);
    fitText(ctx, 'Votre formule.', 680, identityY + 65, 280, 22, '800', family);
    fitText(ctx, 'Votre énergie.', 680, identityY + 94, 280, 22, '800', family);
    ctx.fillStyle = '#b4431b'; fitText(ctx, 'Vos règles.', 680, identityY + 123, 280, 22, '800', family);
    if (label.noCaffeine) {
      ctx.fillStyle = '#9c3717'; fitText(ctx, 'SANS CAFÉINE', 680, 584, 280, 15, '800', family);
    }
    if (flavorImage) {
      ctx.save(); ctx.beginPath(); ctx.arc(725, 982, 45, 0, TAU); ctx.clip();
      var side = Math.min(flavorImage.naturalWidth, flavorImage.naturalHeight);
      ctx.drawImage(flavorImage, (flavorImage.naturalWidth - side) / 2, (flavorImage.naturalHeight - side) / 2, side, side, 680, 937, 90, 90);
      ctx.restore();
    }
    var flavorX = flavorImage ? 782 : 680;
    ctx.fillStyle = '#635b51'; fitText(ctx, 'SAVEUR', flavorX, 962, 960 - flavorX, 13, '800', family);
    ctx.fillStyle = '#201d19'; fitText(ctx, label.flavor && label.flavor !== '—' ? label.flavor : 'À choisir', flavorX, 990, 960 - flavorX, 25, '800', family);
    ctx.fillStyle = '#201d19'; ctx.fillRect(680, 1049, 280, 2);
    var portions = String(label.format || '').match(/^\d+/);
    ctx.fillStyle = '#201d19'; fitText(ctx, portions ? portions[0] : '—', 680, 1082, 85, 38, '800', family);
    ctx.fillStyle = '#635b51'; fitText(ctx, 'PORTIONS', 680, 1111, 90, 13, '500', family);
    if (label.portionWeight) {
      fitText(ctx, '1 DOSE', 780, 1074, 80, 13, '500', family);
      ctx.fillStyle = '#201d19'; fitText(ctx, label.portionWeight, 780, 1101, 80, 23, '800', family);
    }
    if (label.netWeight) {
      ctx.fillStyle = '#635b51'; fitText(ctx, 'POIDS NET', 870, 1074, 90, 13, '500', family);
      ctx.fillStyle = '#201d19'; fitText(ctx, label.netWeight, 870, 1101, 90, 23, '800', family);
    } else {
      ctx.fillStyle = '#635b51'; fitText(ctx, label.concept, label.portionWeight ? 870 : 800, 1101, label.portionWeight ? 90 : 160, 13, '500', family);
    }
    if (Array.isArray(label.composition) && label.composition.length) paintComposition(ctx, label.composition, label.compositionTitle);
    ctx.restore();
    return canvas;
  }

  function createRenderer(canvas, doc) {
    var gl = canvas.getContext('webgl', { alpha: true, antialias: true, premultipliedAlpha: false, powerPreference: 'low-power' });
    if (!gl) throw new Error('WebGL unavailable');
    var buffers = [], shaders = [], program = null, texture = null, destroyed = false;
    function dispose() {
      if (destroyed) return;
      destroyed = true;
      buffers.forEach(function (buffer) { gl.deleteBuffer(buffer); });
      shaders.forEach(function (shader) { gl.deleteShader(shader); });
      if (texture) gl.deleteTexture(texture);
      if (program) gl.deleteProgram(program);
    }
    function compile(type, source) {
      var shader = gl.createShader(type); shaders.push(shader);
      gl.shaderSource(shader, source); gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) throw new Error('Shader unavailable');
      return shader;
    }
    try {
      program = gl.createProgram();
      gl.attachShader(program, compile(gl.VERTEX_SHADER, VERTEX));
      gl.attachShader(program, compile(gl.FRAGMENT_SHADER, FRAGMENT));
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new Error('Program unavailable');
      var locations = {};
      ['uModel', 'uMvp', 'uColor', 'uMode', 'uSpecular', 'uEye', 'uLabel'].forEach(function (name) { locations[name] = gl.getUniformLocation(program, name); });
      var attributes = ['aPosition', 'aNormal', 'aUv'].map(function (name) { return gl.getAttribLocation(program, name); });
      var shapes = geometry(), meshes = {};
      Object.keys(shapes).forEach(function (name) {
        var mesh = shapes[name], vertex = gl.createBuffer(), index = gl.createBuffer();
        buffers.push(vertex, index);
        gl.bindBuffer(gl.ARRAY_BUFFER, vertex); gl.bufferData(gl.ARRAY_BUFFER, mesh.vertices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, index); gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, mesh.indices, gl.STATIC_DRAW);
        meshes[name] = { vertex: vertex, index: index, count: mesh.indices.length };
      });
      var labelCanvas = doc.createElement('canvas'); labelCanvas.width = 2048; labelCanvas.height = 1024;
      texture = gl.createTexture(); gl.bindTexture(gl.TEXTURE_2D, texture);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      var lastLabel = '';
      function draw(name, color, mode, specular) {
        var mesh = meshes[name];
        gl.bindBuffer(gl.ARRAY_BUFFER, mesh.vertex); gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, mesh.index);
        attributes.forEach(function (location, i) {
          gl.enableVertexAttribArray(location); gl.vertexAttribPointer(location, i === 2 ? 2 : 3, gl.FLOAT, false, 32, i === 0 ? 0 : i === 1 ? 12 : 24);
        });
        gl.uniform3fv(locations.uColor, color); gl.uniform1f(locations.uMode, mode); gl.uniform1f(locations.uSpecular, specular);
        gl.drawElements(gl.TRIANGLES, mesh.count, gl.UNSIGNED_SHORT, 0);
      }
      return {
        render: function (frame) {
          if (destroyed || gl.isContextLost()) throw new Error('Context unavailable');
          if (canvas.width !== frame.width || canvas.height !== frame.height) { canvas.width = frame.width; canvas.height = frame.height; }
          gl.viewport(0, 0, canvas.width, canvas.height); gl.clearColor(0, 0, 0, 0);
          gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT); gl.useProgram(program);
          gl.enable(gl.DEPTH_TEST); gl.enable(gl.CULL_FACE); gl.cullFace(gl.BACK);
          gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, texture); gl.uniform1i(locations.uLabel, 0);
          var signature = JSON.stringify(frame.label);
          if (signature !== lastLabel) {
            paintLabel(labelCanvas, frame.label);
            gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, labelCanvas);
            lastLabel = signature;
          }
          var aspect = canvas.width / canvas.height, model = rotation(frame.angle);
          var distance = Math.max(6.15, 3.1 / aspect);
          var view = new Float32Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, -distance, 1]);
          gl.uniform3fv(locations.uEye, [0, 0, distance]);
          gl.uniformMatrix4fv(locations.uModel, false, model);
          gl.uniformMatrix4fv(locations.uMvp, false, multiply(perspective(aspect), multiply(view, model)));
          gl.enable(gl.BLEND); gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA); gl.depthMask(false);
          draw('shadow', [0, 0, 0], 2, 0);
          gl.depthMask(true); gl.disable(gl.BLEND);
          draw('body', [0.99, 0.985, 0.97], 0, 0.44);
          draw('label', [1, 1, 1], 1, 0.05);
          draw('rim', [0.88, 0.875, 0.86], 0, 0.24);
          draw('lid', [0.995, 0.99, 0.978], 0, 0.42);
          draw('grip', [0.985, 0.98, 0.967], 0, 0.3);
          if (gl.getError() !== gl.NO_ERROR) throw new Error('Rendering unavailable');
        },
        invalidateLabel: function () { lastLabel = ''; },
        destroy: dispose
      };
    } catch (error) { dispose(); throw error; }
  }


  var SIZE = 640;
  function readLabel(canvas, doc) {
    var wrap = canvas.closest('[data-at-pot-wrap]');
    function attribute(name, fallback) {
      var nodes = [canvas, wrap, doc.body];
      for (var i = 0; i < nodes.length; i++) {
        var value = nodes[i] && nodes[i].getAttribute(name);
        if (value && value.trim()) return value.trim();
      }
      return fallback;
    }
    return {
      name: attribute('data-formula-name', attribute('data-default-name', 'TA FORMULE')),
      format: '',
      flavor: attribute('data-default-flavor', 'À choisir'),
      concept: attribute('data-label-concept', 'APERÇU')
    };
  }

  function start(win, doc, rendererFactory) {
    rendererFactory = rendererFactory || createRenderer;
    var records = new Map(), queue = new Set(), observer = null;
    var sharedCanvas = null, renderer = null, raf = 0;
    var paused = false, destroyed = false, unavailable = false;
    var fontPromise = doc.fonts && doc.fonts.ready;
    var fontsSettled = !(fontPromise && typeof fontPromise.then === 'function');
    var fontEpoch = 0, standardFontsStarted = false;
    var fontScroll = false;
    function setState(canvas, state) {
      canvas.setAttribute('data-at-pot-state', state);
      var wrap = canvas.closest('[data-at-pot-wrap]');
      if (wrap) wrap.setAttribute('data-at-pot-state', state);
    }
    function release() {
      if (renderer) renderer.destroy();
      renderer = null;
      // Keep the SAME detached canvas so later batches reuse, never multiply, its GPU context.
    }
    function error(canvas) {
      // A failed font refresh must not discard a previously successful static copy.
      if (canvas.getAttribute('data-at-pot-state') !== 'ready') setState(canvas, 'error');
      var record = records.get(canvas);
      if (record) record.needsFonts = false;
      if (observer) observer.unobserve(canvas);
    }
    function schedule() {
      if (!raf && !paused && !destroyed && queue.size && doc.visibilityState !== 'hidden') {
        raf = win.requestAnimationFrame(tick);
      }
    }
    function enqueue(canvas) {
      var record = records.get(canvas);
      if (!record || (record.done && !record.needsFonts) || !canvas.isConnected) return;
      queue.add(canvas);
      schedule();
    }
    function inViewport(canvas) {
      var rect = canvas.getBoundingClientRect();
      return rect.bottom > 0 && rect.right > 0 && rect.top < win.innerHeight && rect.left < win.innerWidth;
    }
    function refreshVisibleFonts() {
      if (paused || destroyed) return;
      records.forEach(function (record, canvas) {
        if (record.needsFonts && (observer ? record.visible : inViewport(canvas))) enqueue(canvas);
      });
    }
    function syncFontScroll() {
      var needed = !observer && !paused && !destroyed && Array.from(records.values()).some(function (record) { return record.needsFonts; });
      if (needed && !fontScroll) win.addEventListener('scroll', refreshVisibleFonts, { passive: true });
      if (!needed && fontScroll) win.removeEventListener('scroll', refreshVisibleFonts);
      fontScroll = needed;
    }
    function fontsReady() {
      if (destroyed || fontsSettled) return;
      fontsSettled = true;
      if (renderer) renderer.invalidateLabel();
      records.forEach(function (record, canvas) {
        if (record.done && canvas.getAttribute('data-at-pot-state') === 'ready') record.needsFonts = true;
      });
      refreshVisibleFonts(); syncFontScroll();
    }
    function tick() {
      raf = 0;
      if (paused || destroyed || doc.visibilityState === 'hidden') return;
      var canvas = queue.values().next().value;
      if (!canvas) { release(); return; }
      queue.delete(canvas);
      var record = records.get(canvas);
      if (record && canvas.isConnected) {
        try {
          if (unavailable) throw new Error('WebGL unavailable');
          var context = canvas.getContext('2d');
          if (!context) throw new Error('Static canvas unavailable');
          if (!standardFontsStarted && doc.fonts && typeof doc.fonts.load === 'function') {
            standardFontsStarted = true; fontEpoch++; fontsSettled = false;
            Promise.resolve().then(function () { return Promise.all([doc.fonts.load('800 42px Manrope'), doc.fonts.load('700 22px Manrope')]); }).then(fontsReady, fontsReady);
          }
          if (!renderer) {
            if (!sharedCanvas) {
              sharedCanvas = doc.createElement('canvas');
              sharedCanvas.width = SIZE; sharedCanvas.height = SIZE;
              sharedCanvas.addEventListener('webglcontextlost', onContextLost);
            }
            try { renderer = rendererFactory(sharedCanvas, doc); }
            catch (creationError) { unavailable = true; throw creationError; }
          }
          renderer.render({ width: SIZE, height: SIZE, angle: 0, label: readLabel(canvas, doc) });
          if (canvas.width !== SIZE || canvas.height !== SIZE) { canvas.width = SIZE; canvas.height = SIZE; }
          // Copy synchronously, before the browser can clear the non-preserved WebGL drawing buffer.
          // Copy compositing replaces transparent pixels, without clearing the old copy before a failure.
          var composite = context.globalCompositeOperation;
          try { context.globalCompositeOperation = 'copy'; context.drawImage(sharedCanvas, 0, 0, SIZE, SIZE); }
          finally { context.globalCompositeOperation = composite; }
          record.done = true; record.needsFonts = false;
          canvas.hidden = false;
          setState(canvas, 'ready');
          var wrap = canvas.closest('[data-at-pot-wrap]');
          var fallback = wrap && wrap.querySelector('[data-at-pot-fallback]');
          if (fallback) fallback.hidden = true;
          if (observer && fontsSettled) observer.unobserve(canvas);
        } catch (renderError) {
          error(canvas);
          record.done = true;
          release();
        }
      }
      if (queue.size) schedule();
      else release();
      syncFontScroll();
    }
    function onContextLost(event) {
      // Static successful copies remain usable; only unfinished cards retain their fallback.
      event.preventDefault();
      unavailable = true;
      release();
      queue.forEach(function (canvas) { error(canvas); var record = records.get(canvas); if (record) record.done = true; });
      queue.clear();
      if (raf) win.cancelAnimationFrame(raf);
      raf = 0;
      syncFontScroll();
    }
    function connectObserver() {
      if (observer || !win.IntersectionObserver) return;
      observer = new win.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var record = records.get(entry.target);
          if (record) record.visible = entry.isIntersecting;
          if (entry.isIntersecting) enqueue(entry.target);
          else queue.delete(entry.target);
        });
        if (!queue.size) release();
      }, { rootMargin: '160px 0px', threshold: 0 });
    }
    function boot(scope) {
      if (destroyed || paused) return;
      connectObserver();
      var nodes = [];
      if (scope.matches && scope.matches('canvas[data-at-pot]')) nodes.push(scope);
      nodes = nodes.concat(Array.prototype.slice.call(scope.querySelectorAll('canvas[data-at-pot]')));
      nodes.forEach(function (canvas) {
        if (records.has(canvas)) return;
        // A successful copy survives section rescans and BFCache.
        var record = { done: canvas.getAttribute('data-at-pot-state') === 'ready', visible: !observer, needsFonts: false };
        records.set(canvas, record);
        if (record.done) { if (observer && !fontsSettled) observer.observe(canvas); return; }
        setState(canvas, 'pending');
        if (observer) observer.observe(canvas);
        else enqueue(canvas);
      });
    }
    function unload(event) {
      records.forEach(function (_record, canvas) {
        if (event.target === canvas || event.target.contains(canvas)) {
          if (observer) observer.unobserve(canvas);
          records.delete(canvas); queue.delete(canvas);
        }
      });
      if (!queue.size) {
        if (raf) win.cancelAnimationFrame(raf);
        raf = 0; release();
      }
      syncFontScroll();
    }
    function sectionLoad(event) { boot(event.target); }
    function pause() {
      paused = true;
      if (raf) win.cancelAnimationFrame(raf);
      raf = 0; queue.clear();
      if (observer) observer.disconnect();
      observer = null;
      release();
      syncFontScroll();
    }
    function resume() {
      if (destroyed) return;
      paused = false;
      connectObserver();
      records.forEach(function (record, canvas) {
        if (!canvas.isConnected) { records.delete(canvas); return; }
        if (!record.done || record.needsFonts || !fontsSettled) {
          if (observer) observer.observe(canvas);
          else if (!record.done || inViewport(canvas)) enqueue(canvas);
        }
      });
      boot(doc);
      syncFontScroll();
    }
    function pageHide(event) { if (event.persisted) pause(); else destroy(); }
    function pageShow(event) { if (event.persisted) resume(); }
    function visibility() {
      if (doc.visibilityState === 'hidden') {
        if (raf) win.cancelAnimationFrame(raf);
        raf = 0; release();
      } else schedule();
    }
    function destroy() {
      if (destroyed) return;
      pause(); destroyed = true; records.clear();
      if (sharedCanvas) sharedCanvas.removeEventListener('webglcontextlost', onContextLost);
      sharedCanvas = null;
      doc.removeEventListener('shopify:section:load', sectionLoad);
      doc.removeEventListener('shopify:section:unload', unload);
      doc.removeEventListener('visibilitychange', visibility);
      win.removeEventListener('pagehide', pageHide);
      win.removeEventListener('pageshow', pageShow);
    }
    doc.addEventListener('shopify:section:load', sectionLoad);
    doc.addEventListener('shopify:section:unload', unload);
    doc.addEventListener('visibilitychange', visibility);
    win.addEventListener('pagehide', pageHide);
    win.addEventListener('pageshow', pageShow);
    boot(doc);
    if (!fontsSettled) fontPromise.then(function () { if (!fontEpoch) fontsReady(); }, function () { if (!fontEpoch) fontsReady(); });
    return { boot: boot, destroy: destroy };
  }
  return {
    packariDimensions: packariDimensions, labelPoint: labelPoint, geometry: geometry, lathe: lathe, multiply: multiply, perspective: perspective,
    rotation: rotation, formulaLines: formulaLines, paintLabel: paintLabel,
    createRenderer: createRenderer, readLabel: readLabel, start: start
  };
});
